import { signal, WritableSignal } from '@angular/core';
import { watch } from '@/utils/watch';
import { LocalStorageSubject } from '@/utils/local-storage-subject';

export function localStorageSignal<T>(key: string, startValue: T): WritableSignal<T> {
  const localStorageSubject = new LocalStorageSubject(key, startValue);
  const writable = signal<T>(localStorageSubject.value);
  watch(writable, (newValue) => {
    localStorageSubject.next(newValue);
  });
  return writable;
}
